<template>
  <div class="home main-frame">
    <div class="container items-center">
      <!-- <img alt="Vue logo" src="../assets/logo.png" />
      <HelloWorld msg="Hahahae" /> -->
      <img class="title-image" alt="hahahae" src="../assets/title.jpg" />
      <p class="caution">
        The audio will play from the next page. Please pay attention to the
        volume!
      </p>
      <p class="caution margin-top">
        If the sound does not play, check the sound system settings.
      </p>
      <p v-if="isJapanese">
        次のページより音声が再生されます。音量にご注意ください。<br />
        音声が再生されない場合はデバイス等のサウンド設定をご確認ください。
      </p>
      <router-link to="/intro" class="button button__blue">NEXT</router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "HomeView",
  props: ["isJapanese"],
  // computed: {
  //   test() {
  //     console.log(this.lang);
  //     return this.lang;
  //   },
  // },
};
</script>

<style lang="scss">
.home {
  background-color: #fff239;
}
// .container {
//   max-width: 866px;
//   margin: 0 auto;
// }
.title-image {
  width: 90%;
}
.caution {
  margin: 0;
  &.margin-top {
    margin-top: 8px;
  }
}
</style>
